export default __webpack_public_path__ + "static/media/anschutz.e28c06ac.png";